import { canUseDOM } from 'exenv';
import get from 'lodash/get';
import cachingService from '../../services/caching_service';
import request from '../../utils/request_util';
import Base from '../base_model';
import log from '../../services/logger_service';

export default class CompanyIndexNext extends Base {
  static fetch({ section, page }, store) {
    const state = store.getState();
    const cacheEnabled = get(state, 'config.cacheEnabled');
    const cacheExpire = get(state, 'config.cacheExpire');
    const cacheNamespace = get(state, 'config.cacheNamespace');
    const host = 'api.fastcompany.com';
    const options = {};
    let pattern = section;
    if (pattern === '0-9') {
      pattern = '%5B0-9%5D';
    }
    // https://api.fastcompany.com/v1/packages/company/search/pattern?page=1&rows_per_page=60&pattern=a

    // Don't worry about this token. Can be public. Talked to Harry.
    const cacheKeyUrl = `https://${host}/v1/packages/companies/search/pattern?page=${Number(
      page
    ) + 1}&rows_per_page=40&pattern=${pattern}&allow_index=1`;
    const cacheKey = `${cacheNamespace}:${cacheKeyUrl}`;

    if (!cacheEnabled) {
      return request.getAsync(cacheKeyUrl, options);
    }

    return cachingService.getAsync(cacheKey).then(function fromCache(cacheRes) {
      if (cacheRes) {
        return Promise.resolve(JSON.parse(cacheRes));
      }

      if (!canUseDOM) {
        log.info(`Requesting: ${cacheKeyUrl} from model.`);
      }

      return request
        .getAsync(cacheKeyUrl, options)
        .then(function fetchSuccess(resp) {
          cachingService.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
    });
  }
}
